import { type Column } from "@tanstack/react-table";
import { ArrowDownUp } from "lucide-react";

import { cn } from "../../../../../lib/utils";
import { type AdministrativeAreaType } from "../../../types";

interface SortableColumnHeaderProps {
  align?: "end" | "start";
  column: Column<AdministrativeAreaType, unknown>;
  label: string;
}

const SortableColumnHeader = ({ align = "start", column, label }: SortableColumnHeaderProps) => {
  const sortDirection = column.getIsSorted();

  return (
    <button
      type="button"
      className={cn(
        "flex min-w-0 w-full items-center gap-2 text-left font-medium text-foreground",
        "cursor-pointer transition-colors hover:text-primary-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        align === "end" && "justify-end text-right"
      )}
      aria-pressed={Boolean(sortDirection)}
      onClick={column.getToggleSortingHandler()}
    >
      <span className="min-w-0 whitespace-normal leading-tight">{label}</span>
      <ArrowDownUp
        className={cn(
          "size-3.5 shrink-0",
          sortDirection ? "text-primary-600" : "text-muted-foreground"
        )}
        aria-hidden="true"
      />
    </button>
  );
};

export { SortableColumnHeader };
